unit NetNumberStatusListType;

interface

uses
  NetNumberStatusType;

type
    TNetNumberStatusListType = array of TNetNumberStatusType;

implementation

end.
